<script setup lang="ts">
import { ref, onMounted, toRaw } from "vue"
import { useQueryStore } from "@/stores/QueryStore.ts"
import { PMs } from "@/compositions/strings.ts"
import { MD5, imageExists } from "@/compositions/utils.ts"

const QueryStore = useQueryStore()

const emit = defineEmits(["user"])

const props = defineProps({
  username: String,
  size: { type: String, default: "xlarge" },
  shape: { type: String, default: "circle" },
})

const getAvatar = ref()
const userInfo = ref()

onMounted(async () => {
  getAvatar.value = await gravatar(props.username || "")

  if (!getAvatar.value) getAvatar.value = `https://www.ibabbleon.com/pix/no_icon.png`
  if (userInfo.value) emit("user", toRaw(userInfo.value))
})

async function gravatar(user: string) {
  if (PMs[user]) {
    userInfo.value = PMs[user]
    return `https://www.ibabbleon.com/pix/${user}.jpg`
  } else if (QueryStore.translators[user] != undefined) {
    userInfo.value = QueryStore.translators[user]
  } else {
    userInfo.value = await QueryStore.getUserDetails(user)
    if (userInfo.value?.email) QueryStore.translators[user] = userInfo.value
    else return ""
  }
  if (!userInfo.value?.email) return ""
  const hash = MD5(`${userInfo.value.user_id ?? ""}${userInfo.value.email}`).trim()
  const babbleimage = `https://www.ibabbleon.com/login/assets/uploads/avatar/${hash}.jpg`
  const img = (await imageExists(babbleimage)) ? babbleimage : `https://www.gravatar.com/avatar/${MD5(userInfo.value.email)}?s=80&d=initials&name=${user}`
  return img
}
</script>

<template>
  <Avatar v-if="getAvatar" :image="getAvatar" :shape="shape" :size="size" :key="getAvatar" />
</template>
